import { render, staticRenderFns } from "./administratorList.vue?vue&type=template&id=7f449cb6&scoped=true"
import script from "./administratorList.vue?vue&type=script&lang=js"
export * from "./administratorList.vue?vue&type=script&lang=js"
import style0 from "./administratorList.vue?vue&type=style&index=0&id=7f449cb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f449cb6",
  null
  
)

export default component.exports